/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Free_AvailableInputs */

const en_directory_launch_free_available = /** @type {(inputs: Directory_Launch_Free_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available to try`)
};

const zh_directory_launch_free_available = /** @type {(inputs: Directory_Launch_Free_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可直接试用`)
};

/**
* | output |
* | --- |
* | "Available to try" |
*
* @param {Directory_Launch_Free_AvailableInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_free_available = /** @type {((inputs?: Directory_Launch_Free_AvailableInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Free_AvailableInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_free_available(inputs)
	return zh_directory_launch_free_available(inputs)
});
export { directory_launch_free_available as "directory.launch.free_available" }